import React from "react";
import { Transition } from "react-transition-group";
import cx from "classnames";
import { isEqual } from "lodash";
import { withRedux } from "helpers";
import NavLink from "./NavLink";
import * as styles from "./navigation.styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MenuIcon from "@material-ui/icons/Menu";
import NotificationsNoneIcon from "@material-ui/icons/NotificationsNone";

class Navigation extends React.Component {
  state = {
    navOpen: false,
  };
  componentDidMount() {
    this.timer = setTimeout(() => (this.loaded = true), 1000);
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  toggleNav = () =>
    this.setState((prevState) => ({ navOpen: !prevState.navOpen }));

  componentDidUpdate(prevProps) {
    if (!this.loaded) return;
    // if (
    //   !isEqual(this.props.activeApp.view.navigation, prevProps.activeApp.view.navigation)
    //   && !this.state.navOpen
    // ) this.setState({ navOpen: true });

    if (
      !isEqual(
        this.props.platformInfo.display.templateId,
        prevProps.platformInfo.display.templateId
      ) &&
      this.state.navOpen
    )
      this.setState({ navOpen: false });
  }

  setTemplate = (templateId) => () => {
    const { activeApp, actions } = this.props;
    // console.log("setting template to " + templateId);
    actions.setTemplate(activeApp.id, templateId);
    this.setState({ navOpen: false });
  };

  goHome = () => {
    const { activeApp } = this.props;
    const { templateId } = this.props.platformInfo.display;
    if (templateId) this.props.actions.setTemplate(activeApp.id, null);
    this.setState({ navOpen: false });
  };

  orderPagesByRank = () => {
    const {
      activeApp: {
        view: {
          navigation: { components },
        },
      },
    } = this.props;
    const order = components.sort((a, b) => a.order - b.order);
    // console.dir(order);
    return order;
  };

  render() {
    const { navigation } = this.props.activeApp.view;
    const { navOpen } = this.state;
    const navComponents = navigation.components || [];
    const {
      activeTemplate: { pageName = "Home" },
    } = this.props;

    const navClass =
      navigation.type === "hamburger"
        ? styles.hamburgerNav
        : styles.fullPageNav;

    const closedNavClass =
      navigation.type === "hamburger"
        ? styles.closedHamburgerNav
        : styles.closedFullPageNav;

    const homeTitle = {
      alignment: 1,
      backgroundColor: "#00000000",
      bold: true,
      font: "TimesNewRoman",
      fontSize: 18,
      italics: false,
      text: "Home",
      textColor: "#000000",
    };

    return (
      <div className={styles.container}>
        <Transition in={navOpen} timeout={600} unmountOnExit>
          {(state) => (
            <div
              className={cx(navClass, state === "exiting" && closedNavClass)}
              style={{
                backgroundColor: navigation.navBarColor,
              }}
            >
              <NavLink title={homeTitle} onClick={this.goHome} />

              {this.orderPagesByRank().map((c) => (
                <NavLink
                  title={c.title}
                  onClick={this.setTemplate(c.templateId)}
                  key={c.templateId}
                />
              ))}
            </div>
          )}
        </Transition>

        <div
          className={styles.toggleBox}
          style={{ background: navigation.navBarColor }}
          onClick={this.toggleNav}
        >
          <div className={styles.toggleBoxWrapper}>
            <div className={styles.hamburgerContainer}>
              {/* <FontAwesomeIcon icon="bars" /> */}
              <MenuIcon fontSize={"large"} />
            </div>
          </div>
          <p className={styles.navHeader} hidden={navOpen}>
            {pageName}
          </p>
          <div className={styles.toggleBoxWrapper} hidden={navOpen}>
            <div className={styles.hamburgerContainer}>
              <NotificationsNoneIcon fontSize={"large"} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRedux(Navigation);
